/**
 * @file 重定向url 主要用于自动跳转h5链接
 */
// eslint-disable-next-line
// @ts-nocheck

import {
  supportLang,
  getLanguage,
  replacePath,
  getOriginPath
} from '@/lang/i18n';
import { langs } from '@/config/setup';
import { isApp, isPC } from '@/utils/tools';
import { h5Host } from '@/config/setup';

export default [
  ({ path, hash, meta, params, query }: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext):void => {
    const pathLang = path.split('/')[1];
    let { h5: h5Path } = meta;
    const { mobilePath } = meta;
    if (h5Path && (isApp() || !isPC())) {
      if (!supportLang(pathLang) && langs.length > 1) {
        const defaultLang = getLanguage();
        // 正常h5、pc用相同的path，兼容不相同的情况
        h5Path = replacePath(h5Path, defaultLang);
      }

      if (!h5Path.includes(pathLang)) {
        h5Path = `/${pathLang === 'fa' ? 'fa-IR' : pathLang}/${h5Path}`;
      }

      const paramsKeys = Object.keys(params);
      if (paramsKeys.length) {
        paramsKeys.forEach(key => {
          if (h5Path.includes(key)) {
            h5Path = h5Path.replace(`:${key}`, params[key]);
          }
        });
      }

      const h5URL = `${h5Host}${h5Path}${location.search}${hash}`;
      window.location.href = h5URL;
    }

    if (mobilePath && !isPC()) {
      next({
        path: pathLang ? `/${pathLang}/${mobilePath}` : mobilePath,
        replace: false,
        query,
        hash
      });
    }
    // h5注册页面 增加记录来源path
    if (getOriginPath(path) === '/register/invite' && from.path != '/') {
      sessionStorage.setItem('register_from', from.path.split('/').filter(Boolean).join('_'));
    }
    // 注册页加人机验证需求，必须是页面跳转
    if (getOriginPath(path) === '/register' && localStorage.getItem('register_refresh') !== 'true') {
      // 记录注册来源
      if (from.path != '/') {
        sessionStorage.setItem('register_from', from.path.split('/').filter(Boolean).join('_'));
      }
      let search = '';
      Object.keys(query).forEach((key: string) => {
        search = search ? `${search}&${key}=${query[key]}` : `?${key}=${query[key]}`;
      });
      localStorage.setItem('register_refresh', 'true');
      window.location.href = `${window.location.origin}/register${search}`;
      return;
    } else if (getOriginPath(path) !== '/register') {
      localStorage.setItem('register_refresh', 'false');
    }

    next();
  }
];
